import React, {useState, useEffect} from 'react'
import styles from './index.module.css'
import Loader from 'react-loader';
import {connect} from 'react-redux';
import {Input} from '../../../assets/NewInputs';
import {createGrantType} from '../../../actions/grants'
import {createNotification} from '../../notifications/notifications';
import CustomCheckbox from '../../../assets/CustomCheckbox/CustomCheckbox';

const mapStateToProps = ({grants}) => {
    const {grant_types_loading} = grants
    return {grant_types_loading}
}
const Index = ({setIsPopup, createGrantType, grant_types_loading}) => {

    const [values,
        setValues] = useState({name: '', is_editable: true}); // название вида стипендии

    const handleClose = () => {
        setValues('');
        setIsPopup(false);
    }

    const handleSubmit = () => {
        if (values.name.trim() == '') 
            return createNotification('error', 'Заполните поле "Название"');
        createGrantType(values);
        handleClose();
    }

    useEffect(() => {
        const close = (e) => {
            if (e.keyCode === 27) {
                handleClose();
            }
        }
        window.addEventListener('keydown', close)
        return () => window.removeEventListener('keydown', close)
    }, [])

    return (
        <div className={styles.popup}>
            <div className={styles.wrapper}>
                <p className={styles.title}>Добавление нового вида стипендии</p>
                <div className={styles.inner}>
                    <Input
                        style={{
                        width: '100%',
                        margin: '2rem auto 2rem',
                        display: 'block'
                    }}
                        placeholder='Название'
                        value={values.name}
                        onChange={(e) => setValues({
                        ...values,
                        name: e.target.value
                    })}/>
                    <CustomCheckbox
                        checked={values.is_editable}
                        onChange={() => {
                        setValues({
                            ...values,
                            is_editable: !values.is_editable
                        })
                    }}
                        label='Редактируемый'
                        style={{
                        margin: '0 0 0 auto'
                    }}/>
                </div>

                <Loader loaded={!grant_types_loading} color='grey'></Loader>

                <div className={styles.buttons}>
                    <div className={styles.buttonClose} onClick={handleClose}>Закрыть</div>
                    <div className={styles.button} onClick={handleSubmit}>Сохранить</div>
                </div>
            </div>
        </div>
    )
}

export default connect(mapStateToProps, {createGrantType})(Index)